import PropTypes from "prop-types";
import {useEffect, useRef} from "react";

const WarnLabelArea = ({children }) => {

    const focusRef = useRef();
    useEffect(() => {
        focusRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
    }, [])

    return (
        <div className="alert alert-warning" ref={useRef}>
            {children}
        </div>
    );
}

WarnLabelArea.propTypes = {
    children: PropTypes.element.isRequired,
}

WarnLabelArea.defaultProps = {
    children: <></>,
}

export default WarnLabelArea;


